import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const TimeIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19 22C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20V19C18.9985 17.7851 18.6813 16.5915 18.0794 15.5361C17.4776 14.4808 16.6118 13.5999 15.567 12.98C15.212 12.77 15 12.433 15 12.079V11.921C15 11.567 15.212 11.23 15.566 11.021C16.6105 10.4004 17.476 9.51927 18.0779 8.46389C18.6799 7.4085 18.9976 6.21497 19 5V4C19.5523 4 20 3.55228 20 3C20 2.44772 19.5523 2 19 2H5C4.44772 2 4 2.44772 4 3C4 3.55228 4.44772 4 5 4V5C5.00242 6.21497 5.32013 7.4085 5.92205 8.46389C6.52398 9.51927 7.38951 10.4004 8.434 11.021C8.788 11.23 9 11.566 9 11.921V12.079C9 12.433 8.788 12.77 8.434 12.979C7.38951 13.5996 6.52398 14.4807 5.92205 15.5361C5.32013 16.5915 5.00242 17.785 5 19V20C4.44772 20 4 20.4477 4 21C4 21.5523 4.44772 22 5 22H19ZM17 4V5C16.9988 6.08231 16.6465 7.13502 15.996 8H8.004C7.35346 7.13502 7.00115 6.08231 7 5V4H17ZM9.45 14.702C10.421 14.128 11 13.148 11 12.079V12H13V12.079C13 13.147 13.579 14.128 14.551 14.702C15.4495 15.2367 16.157 16.0407 16.573 17H7.427C7.8433 16.0406 8.55109 15.2366 9.45 14.702Z"
      fill={color}
    />
  </svg>
);
